<template>
  <div id="app">
    <transition name="fade" appear>
      <div v-show="allitems" class="custcare-search form-group-lg">
        <VueFuse v-model="db" placeholder="Search for help" :keys="keys" :list="allitems" event-name="custChanged" input-Change-Event-Name="custSearchInputChanged"></VueFuse>
        <div id="list">
          <transition-group name="list" tag="ul" class="list-group">
            <li class="list-group-item" v-for="xx in componentResults" :key="xx.id">
              <a :href="xx.Permalink">
                <span v-html="xx.Title"></span>
                <span v-if="xx.Products" class="badge">{{xx.Products}} {{xx.SupportTypes}}</span>
              </a>
            </li>
          </transition-group>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import VueFuse from "./components/VueFuse";
import axios from "axios";

export default {
  data() {
    return {
      prodsupport: [],
      allitems: [],
      term: "",
      termtwo: "",
      type: [],
      defaultAllToggle: true,
      options: {
        keys: ["Title", "Content", "Products"]
      },
      componentResults: [],
      methodResults: [],
      keys: ["Title", "Content", "Products"]
    };
  },
  computed: {},
  created() {
    this.$on("custChanged", results => {
      this.componentResults = results;
                    this.$ga.event({
  eventCategory: 'search',
  eventAction: 'support search',
  eventLabel: this.term})
    });
  },
  mounted() {
    axios
      .get("/json/supportdocs.json")
      .then(response => (this.allitems = response.data.post));
  },
  filters: {
    notags(value) {
      return value.replace(/<[^>]+>/gi, "");
    }
  },
  watch: {

    term() {
      this.$search(this.term, this.allitems, this.options).then(results => {
        this.methodResults = results;

      })
    },
      
  },
  components: { VueFuse }
};
</script>

